import React from 'react';
import { connect } from 'react-redux'
import { Button, message } from 'antd'
import DefaultDeviseTemplateContainer from '../DefaultDeviseTemplateContainer'
import ApplicationForAdmissionForm from './ApplicationForAdmissionForm'
import {
    editApplicationForAdmission,
    getApplicationForAdmission,
    updateApplicationForAdmission,
    indexBorthersMember,
    createBrothersMember,
    createFamilyMember,
    indexFamilyMember,
    uploadApplicationForAdmissionStudImg,
    closeModal
} from '../../actions'
import BrothsMembersModal from './NewStudentForm/BrothsMembersModal'
import FamilyMembersModal from './NewStudentForm/FamilyMembersModal'
import { openModal } from "../../actions";
import { history } from "../../router/history";


class NewStudentBox extends React.Component {

    componentWillMount() {
        this.props.getApplicationForAdmission()
        this.props.indexBorthersMember()
        this.props.indexFamilyMember()
    }


    render() {
        return (
            <div>
                <BrothsMembersModal onSubmit={this.onSubmitBrothsMember} />
                <FamilyMembersModal onSubmit={this.onFamilyMember} />
                <DefaultDeviseTemplateContainer
                    title='入學申請書'
                    menuButton={this.menuButton()}
                    htmlBody={<ApplicationForAdmissionForm onSubmit={this.onSubmit}
                        uploadStudImg={this.uploadStudImg}
                        isLocked={this.props.isLocked} />}
                />
            </div>
        )

    }

    uploadStudImg = (value) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法上傳照片');
            return;
        }
        this.props.uploadStudImg(value)
    }

    onSubmit = (value) => {
        if (this.props.isLocked) {
            message.warning('此表單已鎖定，無法修改資料');
            return;
        }
        this.props.updateApplicationForAdmission(value)
    }

    onSubmitBrothsMember = (value) => {
        this.props.createBrothersMember(value);
        this.props.closeModal('brothers_members_modal')

    }
    onFamilyMember = (value) => {
        this.props.createFamilyMember(value);
        this.props.closeModal('family_members_modal')

    }

    menuButton() {
        return (
            <Button onClick={() => this.goIndex()} >
                返回
            </Button>
        )
    }

    goIndex() {
        history.push('/devise_dashboard')
    }

}

const mapStateToProps = (state) => {
    const applicationData = state.getIn(['ApplicationForAdmissionReducers', 'data']);
    const safeApplicationData = applicationData && applicationData.toJS ? applicationData.toJS() : (applicationData || {});

    return {
        applicationForAdmission: state.getIn(['form']),
        isLocked: !!safeApplicationData.ques_check,
    }
}

const mapDispatchToPorps = (dispatch) => ({
    openModal: (payload) => (
        dispatch(openModal(payload))
    ),
    closeModal: (payload) => (
        dispatch(closeModal(payload))
    ),
    editApplicationForAdmission: () => (
        dispatch(editApplicationForAdmission(dispatch))
    ),
    getApplicationForAdmission: () => (
        dispatch(getApplicationForAdmission(dispatch))
    ),
    updateApplicationForAdmission: (payload) => (
        dispatch(updateApplicationForAdmission(dispatch, payload))
    ),
    indexBorthersMember: () => (
        dispatch(indexBorthersMember(dispatch))
    ),
    createBrothersMember: (payload) => (
        dispatch(createBrothersMember(dispatch, payload))
    ),
    indexFamilyMember: () => (
        dispatch(indexFamilyMember(dispatch))
    ),
    createFamilyMember: (payload) => (
        dispatch(createFamilyMember(dispatch, payload))
    ),
    uploadStudImg: (payload) => (
        dispatch(uploadApplicationForAdmissionStudImg(dispatch, payload))

    )

})

export default connect(mapStateToProps, mapDispatchToPorps)(NewStudentBox)



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/ApplicationForAdmissionContaioner.jsx